import { OrnamentDivider } from "./Ornaments";
import { useLanguage } from "@/lib/i18n";

const HERO_IMAGE = `${process.env.PUBLIC_URL}/suffa-hero-couple.jpg`;

const Hero = () => {
  const { t } = useLanguage();

  return (
    <section className="suffa-hero">
    <svg
      width="0"
      height="0"
      style={{ position: "absolute" }}
      aria-hidden="true"
      focusable="false"
    >
      <defs>
        <clipPath id="suffaArch" clipPathUnits="objectBoundingBox">
          <path d="M0,1 L0,0.4 C0,0.13 0.23,0.015 0.5,0 C0.77,0.015 1,0.13 1,0.4 L1,1 Z" />
        </clipPath>
      </defs>
    </svg>

    <div className="suffa-hero-inner">
      <div className="suffa-hero-copy">
        <OrnamentDivider className="suffa-reveal d-1" />
        <p
          lang="ar"
          dir="rtl"
          className="suffa-verse suffa-reveal d-2"
          data-testid="suffa-hero-arabic-verse"
        >
          وَخَلَقْنَاكُمْ أَزْوَاجًا
        </p>
        <p
          className="suffa-verse-translation suffa-reveal d-3"
          data-testid="suffa-hero-verse-translation"
        >
          {t("“And We created you in pairs.”")}
        </p>
        <p className="suffa-verse-ref suffa-reveal d-3" data-testid="suffa-hero-verse-ref">
          Qur’an 78:8
        </p>
        <h1 className="suffa-title suffa-reveal d-4" data-testid="suffa-hero-heading">
          Suffa Matrimony
        </h1>
        <p className="suffa-tagline suffa-reveal d-5" data-testid="suffa-hero-tagline">
          HALAL RISHTAY <span className="suffa-tagline-dot">•</span> BEHTAR MUSTAQBIL
        </p>
        <h2 className="suffa-hero-local suffa-reveal d-6" data-testid="suffa-hero-local">
          {t("Serving Surat & Nearby Muslim Families — Find Meaningful Rishtas for Nikah.")}
        </h2>
        <p className="suffa-hero-areas suffa-reveal d-6" data-testid="suffa-hero-areas">
          {t("Surat • Navsari • Bharuch • Ankleshwar • Bardoli • Valsad — and members welcome worldwide")}
        </p>
        <p className="suffa-hero-offer suffa-reveal d-6" data-testid="suffa-hero-offer">
          {t("Grand Launch Offer: 20% off registration — ₹400 instead of ₹500, valid through 24 November 2026.")}
        </p>
        <div className="suffa-cta suffa-reveal d-7">
          <a href="/login" className="btn btn-outline btn-lg" data-testid="suffa-hero-login-btn">
            Login
          </a>
          <a
            href="/register"
            className="btn btn-solid btn-lg"
            data-testid="suffa-hero-register-btn"
          >
            Register
          </a>
        </div>
      </div>

      <div className="suffa-hero-visual suffa-reveal d-3">
        <div className="suffa-arch-border">
          <div className="suffa-arch-frame">
            <img
              src={HERO_IMAGE}
              alt="An Arab Muslim couple in traditional dress, seen respectfully from behind in an Islamic courtyard at sunset"
              className="suffa-hero-image"
              data-testid="suffa-hero-image"
            />
          </div>
        </div>
        <span className="suffa-arch-glow" aria-hidden="true" />
      </div>
    </div>
  </section>
  );
};

export default Hero;
